module.exports = __webpack_public_path__ + "img/blue-vk.5d68614e.png";